function QuemSomos() {
  return (
    <div style={{ height: '100%' }}>
      <h1>Sobre</h1>
    </div>
  );
}

export default QuemSomos;
